export default "__VITE_PUBLIC_ASSET__4d69eba1__"